// Decorative SVG watercolor bloom for card corners and hero edges.

interface Props {
  className?: string;
  variant?: 'magenta' | 'cyan' | 'uv' | 'lime' | 'yellow' | 'duo';
  size?: number;
  opacity?: number;
  style?: React.CSSProperties;
}

const COLOR_MAP: Record<string, string[]> = {
  magenta: ['#FF2BD6', '#FF8AEA'],
  cyan:    ['#00F0FF', '#7CF5FF'],
  uv:      ['#7B5CFF', '#B4A2FF'],
  lime:    ['#A7FF2A', '#D6FF8A'],
  yellow:  ['#FFD600', '#FFE96A'],
  duo:     ['#FF2BD6', '#00F0FF'],
};

export function WatercolorBloom({
  className,
  variant = 'duo',
  size = 280,
  opacity = 0.45,
  style,
}: Props) {
  const [c1, c2] = COLOR_MAP[variant];
  const id = `b_${variant}_${size}`;
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" className={className}
         style={{ opacity, pointerEvents: 'none', ...style }} aria-hidden>
      <defs>
        <radialGradient id={`g1_${id}`} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor={c1} stopOpacity="0.9" />
          <stop offset="60%" stopColor={c1} stopOpacity="0.4" />
          <stop offset="100%" stopColor={c1} stopOpacity="0" />
        </radialGradient>
        <radialGradient id={`g2_${id}`} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor={c2} stopOpacity="0.7" />
          <stop offset="70%" stopColor={c2} stopOpacity="0.2" />
          <stop offset="100%" stopColor={c2} stopOpacity="0" />
        </radialGradient>
        <filter id={`blur_${id}`}>
          <feGaussianBlur stdDeviation="4" />
        </filter>
      </defs>
      <g filter={`url(#blur_${id})`}>
        <circle cx="90"  cy="100" r="70" fill={`url(#g1_${id})`} />
        <circle cx="115" cy="80"  r="55" fill={`url(#g2_${id})`} />
        <circle cx="80"  cy="130" r="40" fill={`url(#g1_${id})`} />
      </g>
    </svg>
  );
}
